import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { HOVER_SHADOW } from 'styles/theme';

const StyButton = styled(Button, {
    name: 'StyDashboardsManagerButtonContainer',
})(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    color: theme.palette.darkGrey,
    height: '150px',
    display: 'flex',
    width: '250px',
    borderRadius: theme.spacing(2),
    maxWidth: '400px',
    padding: '32px 24px',
    '& .MuiTypography-body1': {
        textAlign: 'left',
        fontWeight: 600,
    },
    '&:hover': {
        boxShadow: HOVER_SHADOW,
        backgroundColor: theme.palette.primary.background,
    },
    boxShadow: '-4px 8px 24px 0px rgba(0, 0, 0, 0.06)',
}));

type Props = {
    onClick: () => void;
    title: string;
};

const DashboardsManagerButton = ({ onClick, title }: Props): JSX.Element => (
    <div style={{ width: '100%' }}>
        <StyButton
            startIcon={
                <AddCircleIcon color="primary" sx={{ height: 32, width: 32 }} />
            }
            onClick={onClick}
        >
            <Typography>{title}</Typography>
        </StyButton>
    </div>
);

export default DashboardsManagerButton;
